import { render, staticRenderFns } from "./ReportVulnerabilityPageSkeleton.vue?vue&type=template&id=9e9ca67e"
import script from "./ReportVulnerabilityPageSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportVulnerabilityPageSkeleton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports